module.exports = __webpack_public_path__ + "img/Blend.ad967dc3.svg";